const hook = {
    missing_events: 'È necessario fornire almeno un evento.',
    send_test_payload_failed: 'Impossibile inviare il payload di prova: {{message}}',
    endpoint_responded_with_error: 'Il punto di accesso ha risposto con un errore.',
};
export default Object.freeze(hook);
